const userRoles = class {
    static admin: string = "ADMIN"
    static teamCaptain: string = "TeamCaptain"
}

export { userRoles };